import { render } from "./LoaderOverlay.vue?vue&type=template&id=97089a2e&lang=pug"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"

import "./LoaderOverlay.vue?vue&type=style&index=0&id=97089a2e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__